import * as React from "react"
import { useInView } from "react-intersection-observer"

interface Picutre extends React.HTMLProps<HTMLPictureElement> {
	lazy?: boolean
	webP?: string
	jpeg?: string
	png?: string
	className?: string
	src: string
	srcSet?: string
	ref?: React.Ref<HTMLPictureElement>
}

const Picture: React.FC<Picutre> = ({
	lazy = true,
	webP,
	jpeg,
	png,
	src,
	alt,
	srcSet,
	className,
	children,
	...rest
}) => {
	const [ref, inView] = useInView({ triggerOnce: true, rootMargin: "100px" })
	const showImage = lazy ? inView : true
	return (
		<picture ref={ref} className={className || ""} {...rest}>
			{webP && (
				<source type="image/webp" srcSet={showImage ? webP : ""} />
			)}
			{jpeg && (
				<source type="image/jpeg" srcSet={showImage ? jpeg : ""} />
			)}
			{png && <source type="image/png" srcSet={showImage ? png : ""} />}
			{children && children}
			<img
				src={showImage ? src : ""}
				srcSet={showImage ? srcSet || "" : ""}
				alt={alt}
				className={className}
			/>
		</picture>
	)
}

export default Picture
